import Vue from 'vue'

import {
  Alert,
  Button,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Form,
  FormItem,
  Input,
  Menu,
  MenuItem,
  Message,
  Pagination,
  Progress,
  Radio,
  RadioGroup,
  Row,
  Col,
  Tabs,
  TabPane,
  Table,
  TableColumn
} from 'element-ui'

import App from './App.vue'

Vue.use(Alert)
Vue.use(Button)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Pagination)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)

Vue.config.productionTip = false
Vue.prototype.$message = Message

new Vue({
  render: (h) => h(App)
}).$mount('#app')
